
import {Injectable } from '@angular/core';


@Injectable()
export class FilesService{

    constructor() { }
    /*

    getMatches(string: string, regex: string, index?: number) {
    index || (index = 1); // default to the first capturing group
    let matches = [];
    let match;
    while (match = regex.exec(string)) {
        matches.push(match[index]);
    }
    return matches;
}


// Example :
let myString = 'something format_abc something format_def something format_ghi';
let myRegEx = /(?:^|\s)format_(.*?)(?:\s|$)/g;

// Get an array containing the first capturing group for every match
let matches = getMatches(myString, myRegEx, 1);*/


    public b64toBlob(b64Data: string, contentType?: string, sliceSize?: number) {
        contentType = contentType || '';
        sliceSize = sliceSize || 512;

        let byteCharacters = atob(b64Data);
        let byteArrays = [];

        for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            let slice = byteCharacters.slice(offset, offset + sliceSize);

            let byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }

            let byteArray = new Uint8Array(byteNumbers);

            byteArrays.push(byteArray);
        }

        //let blob = new Blob(byteArrays, { type: contentType });
        return new Blob(byteArrays, { type: contentType });
    }

    public downloadFile(base64: string, header: string, fileName: string) {
        let contentType = /:(.*)(?=;)/g.exec(header)[1];
        let blobUrl = URL.createObjectURL(this.b64toBlob(base64, contentType));

        let element = document.createElement('a');
        element.setAttribute('href', blobUrl);
        element.setAttribute('download', fileName);

        element.style.display = 'none';
        document.body.appendChild(element);

        element.click();

        URL.revokeObjectURL(blobUrl);
        document.body.removeChild(element);
    }

    public downloadCsvFile(csvString: string, fileName: string, fileExtension: string) {
        let element = document.createElement('a');
        // https://stackoverflow.com/questions/19492846/javascript-to-csv-export-encoding-issue
        element.setAttribute('href', 'data:text/csv;charset=utf-8,%EF%BB%BF' + encodeURIComponent(csvString));
        element.setAttribute('download', fileName + "." + fileExtension);

        element.style.display = 'none';
        document.body.appendChild(element);

        element.click();

        document.body.removeChild(element);
    }

    public downloadXmlFile(xmlString: string, fileName: string, fileExtension: string) {
        let element = document.createElement('a');
        // https://stackoverflow.com/questions/19492846/javascript-to-csv-export-encoding-issue
        element.setAttribute('href', 'data:text/xml;charset=utf-8,%EF%BB%BF' + encodeURIComponent(xmlString));
        element.setAttribute('download', fileName + "." + fileExtension);

        element.style.display = 'none';
        document.body.appendChild(element);

        element.click();

        document.body.removeChild(element);
    }

    public showFile(base64: string, header: string) {
        let objbuilder = '';
        objbuilder += ('<object data="' + header + base64);
        objbuilder += ('" class="internal"><embed src="');
        objbuilder += (header + base64);
        objbuilder += ('" type="application/pdf" /></object>');

        let win = window.open("", "_blank", "titlebar=yes");
        win.document.title = "File";
        win.document.write('<html><body>' + objbuilder + '</body></html>');
    }
}
